import { gql } from '../../../apollo/__generated__';

export const VOUCHERS = gql(`
  query Vouchers($eventId: ID!) {
    vouchers(eventId: $eventId) {
      id
      code
      amount
    }
  }
`);
